module.exports = __webpack_public_path__ + "static/media/plus_dark.24dd2be3.svg";